import React, { CSSProperties as css } from 'react';
import StandardTile from '../../../general/StandardTile';

const localTileStyle: css = {
  marginBottom: 8,
};

interface LocalPersonTileProps {
  style?: css;
  title?: React.ReactNode;
  children?: React.ReactNode;
  action?: JSX.Element | null;
  collapsible?: boolean;
  initialCollapsed?: boolean;
  loading?: boolean;
  withPin?: boolean;
  isPinned?: boolean;
  property?: string;
  order?: number | null;
  leftIcon?: React.FC<React.SVGProps<SVGSVGElement> & { title?: string }> | null;
  tileBodyClassName?: string;
  withMarginBottom?: boolean;
}

const LocalPersonTile = ({
  style = {},
  title = null,
  children,
  action,
  collapsible = false,
  initialCollapsed = false,
  loading = false,
  withPin = false,
  isPinned = false,
  property = '',
  order=null,
  leftIcon=null,
  tileBodyClassName='',
  withMarginBottom=true,
}: LocalPersonTileProps) => {
  return (
  <StandardTile
    style={{ ...style, ...(withMarginBottom ? localTileStyle : {marginBottom: 0}),  }}
    title={title}
    action={action}
    collapsible={collapsible}
    initialCollapse={initialCollapsed}
    loading={loading}
    withPin={withPin}
    isPinned={isPinned}
    property={property}
    order={order}
    leftIcon={leftIcon}
    tileBodyClassName={tileBodyClassName}
  >
    {children}
  </StandardTile>
)}

export default LocalPersonTile;
